<template>
  <b-popover
    :show.sync="shouldShow"
    target="customer-blocklist-trigger"
    placement="bottomleft"
    triggers=""
  >
    <div class="d-flex flex-column blocklist-suggestions-popover">
      <div v-if="!done" class="d-flex flex-column">
        <div class="d-flex justify-content-between mb-1">
          <p class="mr-2">Blocklist these details?</p>
          <button
            type="button"
            aria-label="Close"
            class="close"
            @click="close()"
          >
            <font-awesome-icon icon="times" />
          </button>
        </div>
        <small class="mb-2">
          This customer has used fraudulent documents, adding their details to a
          blocklist ensures you catch any other documents they try to upload.
          <a
            href="https://help.inscribe.ai/en/articles/3650412-blacklist-database"
            target="_blank"
            >Learn more.</a
          >
        </small>
        <div class="parsed-details d-flex flex-column">
          <div
            v-for="(detail, index) in groupedParsedDetails"
            :key="index"
            class="parsed-name-group text-uppercase my-1 d-flex flex-column"
          >
            <b-form-checkbox
              name="checkbox-1"
              :checked="selectedDetails.includes(index)"
              :value="true"
              :unchecked-value="false"
              @change="() => onCheck(index)"
            >
              <div
                v-if="selectedDetails.includes(index)"
                class="d-flex flex-column w-100"
              >
                <inline-text-input
                  :value="detail.name.toUpperCase()"
                  placeholder="Customer name"
                  @input="
                    $emit('input-text', index, 'name', $event.target.value)
                  "
                />
                <inline-text-input
                  :value="detail.address.toUpperCase()"
                  placeholder="Customer address"
                  @input="
                    $emit('input-text', index, 'address', $event.target.value)
                  "
                />
              </div>
              <div v-else class="d-flex flex-column w-100">
                <span class="p-1">{{ detail.name }}</span>
                <span class="p-1">{{ detail.address }}</span>
              </div>
            </b-form-checkbox>
          </div>
          <loading-button
            size="sm"
            :disabled="selectedDetails.length === 0"
            :loading="loading"
            class="mt-2 mr-auto"
            @click="addSelectedItemsToBlocklist"
          >
            Blocklist
            <span v-if="selectedDetails.length > 0"
              >({{ selectedDetails.length }})</span
            >
          </loading-button>
        </div>
      </div>
      <div v-else>
        <p>The following item(s) were successfully added to the blocklist</p>
        <div class="d-flex flex-column w-100 added-items mt-3 pl-2">
          <div
            v-for="detailIndex in selectedDetails"
            :key="detailIndex"
            class="d-flex flex-column w-100 mb-2"
          >
            <span>{{ groupedParsedDetails[detailIndex].name }}</span>
            <span>{{ groupedParsedDetails[detailIndex].address }}</span>
          </div>
        </div>
        <p class="my-2">
          <small
            >You can view and edit the blocklist in
            <router-link :to="{ name: 'blocklist-view' }"
              >your settings</router-link
            ></small
          >
        </p>
        <b-button size="sm" class="mt-2 mr-auto" @click="close()">
          Close
        </b-button>
      </div>
    </div>
  </b-popover>
</template>

<script>
import { InlineTextInput, LoadingButton } from '@inscribe/ui-kit';
import { mapMutations } from 'vuex';

export default {
  components: {
    'inline-text-input': InlineTextInput,
    'loading-button': LoadingButton,
  },
  props: {
    customer: {
      type: Object,
      required: true,
    },
    groupedParsedDetails: {
      type: Array,
      default: () => [],
      required: true,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectedDetails: [],
      loading: false,
      done: false,
      shouldShow: this.show,
    };
  },
  watch: {
    show: {
      handler: function (val) {
        this.shouldShow = val;
      },
    },
  },
  methods: {
    ...mapMutations(['setShowBlocklistSuggestions']),
    close() {
      this.shouldShow = false;
      this.$emit('update:show', false);
      this.setShowBlocklistSuggestions(false);
    },
    onCheck(index) {
      if (this.selectedDetails.includes(index)) {
        this.selectedDetails = this.selectedDetails.filter(
          (val) => val !== index,
        );
      } else {
        this.selectedDetails = [...this.selectedDetails, index];
      }
    },
    addSelectedItemsToBlocklist() {
      if (this.selectedDetails.length > 0) {
        this.loading = true;
        Promise.all(
          this.selectedDetails.map((detailIndex) =>
            this.$store.dispatch(
              'addBlocklist',
              this.groupedParsedDetails[detailIndex],
            ),
          ),
        )
          .then(() => {
            this.loading = false;
            this.done = true;
          })
          .catch(() => {
            this.loading = false;
          });
      }
    },
  },
};
</script>

<style lang="scss">
.blocklist-suggestions-popover {
  padding: 8px;
  width: 250px;

  .close {
    font-size: $font-size-small;
  }

  .parsed-name-group {
    .custom-control.custom-checkbox {
      padding-left: 1.25rem;
    }

    label {
      &::before,
      &::after {
        left: -1.25rem;
        height: 0.75rem;
        top: 0.4rem;
        width: 0.75rem;
      }

      input,
      span {
        font-size: $font-size-small;
        width: 100% !important;
      }
    }
  }

  .added-items {
    span {
      font-size: $font-size-small;
    }
  }
}
</style>
